window.$log = {
  // Need to change to accommodate prefer-rest-params rule of eslint
  // See https://eslint.org/docs/rules/prefer-rest-params
  log: (...args) => {
    //n Arguments
    if (window.APP.CONFIGURATION.DEBUG) console.log.apply(undefined, args);
  },
  level: (level) => {
    if (window.APP.CONFIGURATION.DEBUG) console.level = level;
  },
  info: (...args) => {
    //n Arguments
    if (window.APP.CONFIGURATION.DEBUG) console.info.apply(undefined, args);
  },
  error: (...args) => {
    //n Arguments
    if (window.APP.CONFIGURATION.DEBUG) console.error.apply(undefined, args);
  },
  warn: (...args) => {
    //n Arguments
    if (window.APP.CONFIGURATION.DEBUG) console.warn.apply(undefined, args);
  },
};

module.exports = {
  log: window.log,
};
